var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',_vm._b({attrs:{"label":"combined_sku_name","track-by":"id"},on:{"input":_vm.update}},'Select',{value: _vm.value, request: _vm.request, placeholder: _vm.placeholder, allowEmpty: _vm.allowEmpty},false))}
var staticRenderFns = []

export { render, staticRenderFns }